import { useTranslation } from "react-i18next";

import { HaNViewStoreContext, isBookingDraftDirty } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";
import { useDestructiveDialog } from "@hooks";

/**
 * Runs something that throws away the booking being filled in: closing its details, opening something else, or
 * changing floor or building. When the booking has changes it asks first, and only runs it once that's confirmed.
 * Opening the same room again keeps the booking, so that doesn't ask.
 */
export const useConfirmDiscardingBooking = () => {
  const { t } = useTranslation();
  const viewStore = useRequiredContext(HaNViewStoreContext);
  const { destructiveDialog } = useDestructiveDialog();

  return (discard: () => void, nextSelectedId: string | null = null) => {
    const { bookingDraft } = viewStore.getState();

    if (!isBookingDraftDirty(bookingDraft) || bookingDraft?.roomId === nextSelectedId) {
      discard();

      return;
    }

    destructiveDialog(
      t("meeting:DiscardEventChangesTitle"),
      t("meeting:DiscardEventChangesMessage"),
      "warning",
      t("meeting:DiscardEventChangesConfirm"),
    ).then(isConfirmed => {
      if (isConfirmed) discard();
    });
  };
};
